import type { TOC } from '@ember/component/template-only'
import { ContentTile } from 'teacher-ui-client/components/tiles/content'
import { UiButtonLink } from 'teacher-ui-client/components/ui-button/link'
import { ButtonAppearance } from 'teacher-ui-client/components/ui-button/themes'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { pdfDownloadEvent } from 'teacher-ui-client/modifiers/pdf-download-event'
import { t } from 'ember-intl'

interface Args {
  image?: string
  title: string
  productFormatted: string
  description?: string
  pdfUrl: string
}

interface Signature {
  Args: Args
  Element: Element
}

export const TilesPdfEntry: TOC<Signature> = <template>
  <ContentTile class="flex flex-col p-6" ...attributes>
    <div class="mb-4 space-y-2">
      {{#if @image}}<img src={{@image}} alt={{@title}} class="border-dusty-black-100 mx-auto h-40 border" />{{/if}}
      <p class="text-center">{{@productFormatted}}</p>
      <p class="text-center font-bold">{{@title}}</p>
      {{#if @description}}
        <p class="text-center">{{@description}}</p>
      {{/if}}
    </div>

    <div class="mt-auto text-center">
      <UiButtonLink
        href={{@pdfUrl}}
        target="_blank"
        rel="noopener noreferrer"
        @appearance={{ButtonAppearance.regular}}
        {{pdfDownloadEvent category="Fast Phonics > Quick Links" label=@title}}
      >
        <PhosphorIcon @icon="phosphor-download-fill" />
        {{t "components.tiles.pdfEntry.downloadPdf"}}
      </UiButtonLink>
    </div>
  </ContentTile>
</template>

export default TilesPdfEntry
